import { toast } from "react-toastify";
import { _delete, _post } from "../../Api";

export function updateQrCodes(merchantId, qrCodes, newData) {
  let data = [];
  for (let i in qrCodes) {
    data.push({
      identifier: qrCodes[i].identifier,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/sp_qr_codes", data)
    .then((res) => {
      // let newQrCodes = [...qrCodes];
      // qrCodes.forEach((qrCode, index) => {
      //   newQrCodes[index] = { ...qrCode };
      //   Object.keys(newData[index]).forEach((key) => {
      //     newQrCodes[index][key] = newData[index][key];
      //   });
      //
      //   newQrCodes[index].updated_at = new Date().getTime();
      // });

      toast.success("Webcodes updated", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}

export function deleteQrCodes(merchantId, qrCodes) {
  let data = [];
  for (let i in qrCodes) {
    data.push({
      identifier: qrCodes[i].identifier,
    });
  }
  return _delete("/nova/v2/merchant/" + merchantId + "/sp_qr_codes", data)
    .then((res) => {
      // let newQrCodes = [...qrCodes];
      // qrCodes.forEach((qrCode, index) => {
      //   newQrCodes[index] = { ...qrCode };
      //   Object.keys(newData[index]).forEach((key) => {
      //     newQrCodes[index][key] = newData[index][key];
      //   });
      //
      //   newQrCodes[index].updated_at = new Date().getTime();
      // });

      toast.success("Webcodes deleted", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}
